import axios from 'axios'
// import store from '@/store/'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  // const port = store.getters.theApis.fdc.sitePort
  // return {
  //   // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
  //   url: env ? ((process.env.VUE_APP_HTTPS_ENABLE === 'true' ? 'https://' : 'http://') + store.getters.theApis.fdc.siteIp) : 'http://localhost',
  //   port: env ? port : '15003',
  //   smryPort: env ? port : '15004'
  // }
  return {
    // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    smryPort: env ? '' : ':'.concat('20004')
  }
}

export default {
  getPreprocPlanParamInfo: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/dps/preproc/param/list', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getPreprocPlanInfo: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/dps/preproc/plan', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  savePreprocPlanInfo: async (plan) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dps/preproc/save', plan)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  deletePreprocPlanInfo: async (plan) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dps/preproc/delete', plan)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
